/**
 * regresa un objeto Json con los parametros de un querystring
 */
const getAllParametersFromQueryString = (queryString) => {
  const params = {};
  const res = queryString.split('&');
  res.forEach(item => {
    const par = item.split('=');
    if (par[0] && par[1]) {
      const keey = par[0];
      params[keey] = par[1];
    }
  });
  return params;
};

/**
 *
 * @param urlToParse
 * Example:
 *  urlToParse: http://microfwk-tv2sony.clarovideo.net/services/user/register?password=68119191&firstname=nombre&lastname=apellido&object_type=A&api_version=v5.5&userdetectws=true&numberField=5556482707&authpn=amco&authpt=12e4i8l6a581a&device_manufacturer=sony&device_model=generic&device_category=tv&device_type=generic&format=json&HKS=ki1vo1tvui04scjkf0ppo6dh60
 *
 *  return {
 *          url: http://microfwk-tv2sony.clarovideo.net/services/user/register,
 *          params: {
 *                      password: '68119191',
 *                      firstname: 'nombre',
 *                      ... ... ... ...
 *                  }
 *         }
 */
const decomposeUrl = (urlToParse) => {
  const parsedUrl = {
    url: undefined,
    params: undefined
  };
  if (!urlToParse) {
    return parsedUrl;
  }
  const qsArray = urlToParse.split('?');
  if (qsArray[0]) {
    parsedUrl.url = qsArray[0];
  }
  if (qsArray[1]) {
    parsedUrl.params = getAllParametersFromQueryString(qsArray[1]);
  }
  return parsedUrl;
};

export const utils = {
  decomposeUrl
};



// WEBPACK FOOTER //
// ./src/AAF/Auth/utils.js